import { createFileRoute } from '@tanstack/react-router';
import { zodValidator } from '@tanstack/zod-adapter';

import { DormancyDetailSearchSchema } from './-constants';

export const Route = createFileRoute(
  '/_staff/accesses/_layout/alerts/dormancy/$softwareId/',
)({
  validateSearch: zodValidator(DormancyDetailSearchSchema),
});
